import {InjectionToken, Type} from '@angular/core';

export interface ContestLessonsComponentContract {}

export const CONTEST_LESSONS_COMPONENT = new InjectionToken<Type<ContestLessonsComponentContract>>(
    'CONTEST_LESSONS_COMPONENT'
);
